import styled from "styled-components";
import { screenSizes } from "../../styles/theme";

// Header and title
export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
`;

export const TitleContainer = styled.div`
  color: #091c00;
  h2 {
    font-family: "Manrope", sans-serif;
    font-size: 50px;
    font-weight: 700;
    margin: 0;
    letter-spacing: -2px;
    @media (max-width: ${screenSizes.L}px) {
      font-size: 32px;
      line-height: 48px;
      letter-spacing: 0;
    }
  }
`;

// owner nfts section
export const OwnerSection = styled.section`
  padding: 80px;
  padding-top: 0;
  @media (max-width: ${screenSizes.L}px) {
    padding: 1rem;
  }
`;

export const OwnerCard = styled.div`
  padding: 10px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  display: flex;
  gap: 10px;

  img {
    height: 120px;
    width: 100px;
  }

  .content {
    width: 100%;
    padding: 10px;
    padding-bottom: 0;
    padding-right: 0;
    .titleContainer {
      display: flex;
      align-items: center;
      gap: 10px;

      p {
        margin: 0;
        font-size: 12px;
        font-weight: 400;
        color: #737376;
      }
    }
  }

  .heading {
    margin: 0;
    margin-bottom: 10px;
    font-size: 15px;
    font-weight: 700;
    color: #091c00;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .infoBox {
    margin-top: 20px;
    padding: 10px;
    background-color: #f6f6f6;
    display: flex;
    align-items: center;
    gap: 20px;

    .ecoscore,
    .donation {
      h6 {
        margin: 0;
        font-size: 12px;
        font-weight: 400;
        color: #737376;
      }
      p {
        margin: 0;
        font-size: 12px;
        font-weight: 400;
        color: #091c00;
      }
    }
  }
`;

// Trending Section
export const TrendingNFTsSection = styled.section`
  padding: 80px;
  padding-top: 0;
  @media (max-width: ${screenSizes.L}px) {
    padding: 1rem;
  }
`;

export const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  @media (max-width: ${screenSizes.L}px) {
    padding-inline: 2px;
  }
`;

export const Card = styled.div`
display: flex;
flex-direction: column;
padding: 12px;
background-color: #fff;
border: 1px solid rgba(9, 28, 0, 0.1);
@media (max-width: ${screenSizes.L}px) {
  flex-direction: row;
}
img {
  height: 224px;
  width: 100%;
  margin-bottom: 10px;
  background-size: cover;
  background-position: center;
  @media (max-width: ${screenSizes.L}px) {
    height: 100%;
    width: 110px;
    margin-right: 10px;
    object-fit: contain;
    margin-bottom: 0;
  }
}
.icon {
  margin-bottom: 5px;
}
.content-wrapper {
@media (max-width: ${screenSizes.L}px) {
 display: flex;
 flex-direction: column;
 gap: 5px;
}
}
h5 {
  margin: 0;
  font-family: "Manrope", sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: rgba(9, 28, 0, 1);
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
}
h6 {
  margin: 0;
  font-family: "Manrope", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: rgba(9, 28, 0, 1);
}
`;

export const NameSection = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  span {
    font-family: Manrope;
    font-size: 12px;
    font-weight: 400;
    line-height: 16.39px;
    color: rgba(115, 115, 118, 1);
  }
`;

export const BidButton = styled.button`
  cursor: pointer;
  width: 100%;
  outline: none;
  padding: 8px 24px;
  gap: 12px;
  border-radius: 40px;
  border: 2px solid rgba(9, 28, 0, 1);
  opacity: 0px;
  background: #fff;
  font-family: Manrope;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  color: rgba(9, 28, 0, 1);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonContainer = styled.div`
  margin-top: 40px;
  text-align: center;
`;

export const PriceAndScore = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: ${screenSizes.L}px) {
    padding-top: 5px;
  }
`;

export const Rating = styled.div<{ value: number }>`
  display: flex;
  align-items: center;
  background-color: ${({ value }) =>
    value <= 3 ? "#C7FFC5" : value >= 6 ? "#FFC5C5" : "#feffc5"};
  border: 1px solid rgba(9, 28, 0, 0.1);
  padding: 0 8px;
  border-radius: 40px;
  min-width: 70px;
  justify-content: center;
  span {
    font-size: 14px;
    font-weight: 400;
    color: #091c00;
  }
`;
